export const EDIT_SUCCESS = 'Инструкция коннектора обновлена';
export const EDIT_ERROR = 'Не удалось обновить инструкцию коннектора';
